"use strict";

exports.PLUGIN_ADDED = 'pluginAdded';
exports.PLUGIN_REMOVED = 'pluginRemoved';
exports.CREATOR_ADDED = 'creatorAdded';
exports.CREATOR_REMOVED = 'creatorRemoved';
exports.CREATOR_CHANGED = 'creatorChanged';
exports.DEFAULT = 'default';